import save from './save'
import {saveDecorator} from './saveDecorator'

export {saveDecorator}
export default save
